var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingleAccent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "23px",
    viewBox: "0 0 19 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-single-accent",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#EE6701"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,14.5 L6.5,14.5 C3.186,14.5 0.5,17.186 0.5,20.5 L0.5,21.5 C0.5,21.5 3.625,22.5 9.5,22.5 C15.375,22.5 18.5,21.5 18.5,21.5 L18.5,20.5 C18.5,17.186 15.814,14.5 12.5,14.5 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,5.5 C4.5,2.739 6.739,0.5 9.5,0.5 C12.261,0.5 14.5,2.739 14.5,5.5 C14.5,8.261 12.261,11.5 9.5,11.5 C6.739,11.5 4.5,8.261 4.5,5.5 Z",
    id: "Stroke-3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleAccent);
export default __webpack_public_path__ + "static/media/single-accent.e7b39f8fc877bedfd80aeeaca592c9a5.svg";
export { ForwardRef as ReactComponent };